<template>
  <div>
    <app-header></app-header>
    <product-list></product-list>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppHeader from "../../components/common/AppHeader";
import AppFooter from "../../components/common/AppFooter";
import SearchFilter from "../../components/mall/SearchFilter";
import ProductList from "../../components/mall/ProductList";
export default {
  components: {
    AppHeader,
    AppFooter,
    SearchFilter,
    ProductList
  }
};
</script>

<style lang="less" scoped>
</style>